/* eslint-disable react/jsx-props-no-spreading */
import { Input } from 'antd';
import PropTypes from 'prop-types';
import './NumericInput.css';

function SimpleNumericInput(props) {
  // eslint-disable-next-line react/prop-types
  const { onChange, maxLength } = props;

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    // const reg = /^-?\d*(\.\d*)?$/;
    const reg2 = /^[0-9]+$/;
    if (reg2.test(inputValue) || inputValue === '') {
      onChange(inputValue);
    }
  };

  return <Input {...props} onChange={handleChange} maxLength={maxLength} />;
}

SimpleNumericInput.propTypes = {
  value: PropTypes.string
};

SimpleNumericInput.defaultProps = {
  value: ''
};

export default SimpleNumericInput;
